
let gInterfaceInstance = undefined;

function set(pInstance) {
  if (gInterfaceInstance) {
    console.warn('Overwriting the original interface instance.');
  }
  gInterfaceInstance = pInstance;
}

function get() {
  if (!gInterfaceInstance) {
    console.warn('Interface has not been initialized.');
  }
  return gInterfaceInstance;
}

module.exports = {
  machineAppInterface: {
    get,
    set,
  }
};